export default {"src":"/_next/static/media/tripAdvisorIcon.c7cb9cf8.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};